module.exports = __webpack_public_path__ + "static/media/gif_atendimento_vacinacao.6b044e97.gif";